import * as React from "react";
import { styled, alpha } from "@mui/material";
import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles((theme) => ({
  bgPaper: {
    backgroundColor: theme.palette.background.secondary,
    width: theme.spacing(60),
    height: theme.spacing(75),
    padding: theme.spacing(4),
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    color:theme.palette.text.main,
    [theme.breakpoints.down('sm')]: {
     
      width: theme.spacing(50),
      // height: theme.spacing(),
      // padding: theme.spacing(2),
    },
  },
 
  formHeader: {
    fontSize: theme.spacing(3),
    fontWeight: "bold",
    color:theme.palette.text.main
  },
  formDesc: {
    fontSize: theme.spacing(2),
    color: theme.palette.text.main,
  },

}));
